import React from 'react'
import CoopLogo from '../../Images/TopbarImg/BannerLogo.jpg'
import FlagImg from '../../Images/TopbarImg/FlagNP.gif'
import '../../css/lower-topbar.css'
import TopbarImgSlider from '../Main/TopbarImgSlider'

const LowerTopbar = () => {
    return (
        <>
            <div className='lower-topbar'>
                <div className='left-fixed'></div>
                <div className="container">
                    <div className="topmain">
                        <div className="col-site">
                            <div className="site-logo">
                                <a href='/'><img src={CoopLogo} alt='Img-1' /></a>
                            </div>
                            <div className="award-info">
                                <img className='flag1' src={FlagImg} alt='Img-2' />
                            </div>
                            <div className='award-info-slider'>
                                <div className='logo-slider'>
                                    <TopbarImgSlider />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default LowerTopbar